// @flow

import {createReducer, createActions} from 'reduxsauce';
import Immutable from 'seamless-immutable';

/* ------------- Types and Action Creators ------------- */

const {Types, Creators} = createActions({
  createSpecificUserRequest: ['user'],
  createSpecificUserSuccess: ['user'],
  createSpecificUserError: ['error'],

  createMultipleUserRequest: ['users'],
  createMultipleUserSuccess: ['msg'],
  createMultipleUserError: ['error']
});

export const createUserTypes = Types;
export default Creators;

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  fetching: false,
  isCreate: false,
  userDetails: {},
  multipleUser: false,
  error: undefined,
});

/* ------------- Reducers ------------- */

export const processCreateSpecificUserRequest = (state: Object) => state.merge({
  fetching: true,
  error: undefined,
  userDetails: {},
  isCreate: false,
});

export const processCreateSpecificUserSuccess = (state: Object, {user}: Object) => state.merge({
  fetching: false,
  error: undefined,
  userDetails: user,
  isCreate: true,
});

export const processCreateSpecificUserError= (state: Object, {error}: Object) => state.merge({
  fetching: false,
  error,
  userDetails: {},
  isCreate: false
});


export const processCreateMultipleUserRequest = (state: Object) => state.merge({
  fetching: true,
  error: undefined,
  multipleUser: false
});

export const processCreateMultipleUserSuccess = (state: Object, {msg}: Object) => state.merge({
  fetching: false,
  error: undefined,
  multipleUser: true
});

export const processCreateMultipleUserError= (state: Object, {error}: Object) => state.merge({
  fetching: false,
  error,
  multipleUser: true
});
/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.CREATE_SPECIFIC_USER_REQUEST]: processCreateSpecificUserRequest,
  [Types.CREATE_SPECIFIC_USER_SUCCESS]: processCreateSpecificUserSuccess,
  [Types.CREATE_SPECIFIC_USER_ERROR]: processCreateSpecificUserError,

  [Types.CREATE_MULTIPLE_USER_REQUEST]: processCreateMultipleUserRequest,
  [Types.CREATE_MULTIPLE_USER_SUCCESS]: processCreateMultipleUserSuccess,
  [Types.CREATE_MULTIPLE_USER_ERROR]: processCreateMultipleUserError,
});
